// Module
var code = "<h2 id=\"consolidation\">Consolidation</h2> <p>Consolidation lets you combine multiple loans into one with a new repayment schedule. See if consolidation is right for you. </p> ";
// Exports
export default code;